import { render, staticRenderFns } from "./CreateKeywordCampaignSidebar.vue?vue&type=template&id=372e4648&scoped=true"
import script from "./CreateKeywordCampaignSidebar.vue?vue&type=script&lang=js"
export * from "./CreateKeywordCampaignSidebar.vue?vue&type=script&lang=js"
import style0 from "./CreateKeywordCampaignSidebar.vue?vue&type=style&index=0&id=372e4648&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372e4648",
  null
  
)

export default component.exports